import React, { useState } from "react";
import "./MyView.scss";
import FiltersSidebar from "../../Components/FiltersSidebar/FiltersSidebar";
import TopBar from "../../Components/TopBar/TopBar";
import ExpertCard from "../../Components/ExpertCard/ExpertCard";
import PublishEditModal from "../../Components/PublishEditModal/PublishEditModal";

export default function MyView() {
  const [showFilters, setShowFilters] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([
    "Live",
    "Yet To Live",
    "Updated",
  ]);

  const [publishOpen, setPublishOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const activeFiltersCount = selectedFilters.length;

  const cardsData = [
    {
      id: 1,
      coin: "Bitcoin Cash",
      symbol: "B",
      price: 555.75,
      change: 4.85,
      percent: 0.78,
      date: "Dec 19, 2025, 03:35 PM IST",
      risk: 900,
      supportLow: 1000,
      supportHigh: 1100,
      resistanceLow: 1100,
      resistanceHigh: 1200,
      gap: 45.8,
      cmp: 1005.5,
    },
    {
      id: 2,
      coin: "Ethereum",
      symbol: "E",
      price: 3120.5,
      change: 38.2,
      percent: 1.24,
      date: "Dec 19, 2025, 02:15 PM IST",
      risk: 2800,
      supportLow: 2900,
      supportHigh: 3000,
      resistanceLow: 3300,
      resistanceHigh: 3500,
      gap: 32.4,
      cmp: 3180,
    },
    {
      id: 1,
      coin: "Bitcoin Cash",
      symbol: "B",
      price: 555.75,
      change: 4.85,
      percent: 0.78,
      date: "Dec 19, 2025, 03:35 PM IST",
      risk: 900,
      supportLow: 1000,
      supportHigh: 1100,
      resistanceLow: 1100,
      resistanceHigh: 1200,
      gap: 45.8,
      cmp: 1005.5,
    },
  ];

  const handleEdit = (id) => {

    const card = cardsData.find((item) => item.id === id);
    setSelectedCard(card);
    setPublishOpen(true);

  };

  return (

    <div className="crypto-layout">
      <main className="content">

        <TopBar
          onFilterClick={() => setShowFilters(true)}
          onPublishClick={() => setPublishOpen(true)}
          activeFiltersCount={activeFiltersCount}
        />

        {cardsData.map((card) => (
          <ExpertCard
            key={card.id}
            data={card}
            onEdit={handleEdit}
          />
        ))}

      </main>

      <PublishEditModal
        open={publishOpen}
        cardData={selectedCard}
        onClose={() => setPublishOpen(false)}
      />

      {showFilters && (
        <div className="filter-popup">
          <div className="filter-popup-body">

            <FiltersSidebar
              isPopup
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
              onClose={() => setShowFilters(false)}
            />

          </div>
        </div>
      )}

    </div>
  );
}